<mat-card>
  <mat-card-header>
    <mat-card-title>{{cradlepoint.name}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    @if (cradlepoint.state == 'online') {
      <span id="network-health-badge-green">
        <mat-icon matTooltip="Health: good" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    @if (cradlepoint.state == 'offline') {
      <span id="network-health-badge-red">
        <mat-icon matTooltip="Health: bad" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    @if (cradlepoint.url) {
      <span>
        <a [href]="cradlepoint.url" target="_blank"><mat-icon matTooltip="View in Cradlepoint Dashboard">link</mat-icon></a>
      </span>
    }
    @if (cradlepoint.state == 'online') {
      <p><b>Status:</b> Online</p>
    }
    @if (cradlepoint.state == 'offline') {
      <p><b>Status:</b> Offline</p>
    }
    <p><b>Mac:</b> {{cradlepoint.mac}}</p>
    <p><b>IPv4 Address:</b> {{cradlepoint.ipv4_address}}</p>
    <p><b>Serial:</b> {{cradlepoint.serial_number}}</p>
    <p><b>Carrier:</b> {{cradlepoint.carrier}}</p>
  </mat-card-content>
</mat-card>